import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-loan-radio',
  templateUrl: './loan-radio.component.html',
  styleUrl: './loan-radio.component.scss',
  standalone: false
})
export class LoanRadioComponent {
  @Input({ required: true }) control!: FormControl;
  @Input() useQuestion: boolean = false;
  @Input() values: string[] = [];
}
